var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { formatCount, formatDate, formatDateAtTime, formatDecimal, formatDuration, formatKm, formatPercent } from '../../../../domain';
/**
 * Um numero grande com rotulo, icone e uma explicacao no `title` - o `KpiCard` da
 * referencia.
 *
 * `value` e `subtitle` chegam JA FORMATADOS: sao texto, e ninguem os plota nem os
 * exporta. As series abaixo fazem o contrario, e o comentario delas diz por que.
 */
let KpiScope = class KpiScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '-';
        /** O icone, pelo nome - ver `lib/lucide-icons.ts` na view. */
        this.icon = '';
        /** A cor do quadradinho do icone: `indigo`, `emerald`, `amber`, `sky` ou `rose`. */
        this.accent = 'indigo';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], KpiScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], KpiScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], KpiScope.prototype, "subtitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], KpiScope.prototype, "help", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], KpiScope.prototype, "icon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], KpiScope.prototype, "accent", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], KpiScope.prototype, "openHint", void 0);
KpiScope = __decorate([
    Observable
], KpiScope);
export { KpiScope };
/** Uma etapa do funil. O percentual e calculado na view, sobre a primeira etapa. */
let FunnelStepScope = class FunnelStepScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = 0;
        /** A fracao sobre o primeiro degrau, em porcentagem - calculada pelo presenter. */
        this.share = 0;
    }
    get valueLabel() {
        return formatCount(this.value);
    }
    get shareLabel() {
        return formatPercent(this.share);
    }
    /** A largura da barra, em %: a fracao, presa em 100. */
    get barWidth() {
        return Math.min(this.share, 100);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], FunnelStepScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FunnelStepScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], FunnelStepScope.prototype, "share", void 0);
FunnelStepScope = __decorate([
    Observable
], FunnelStepScope);
export { FunnelStepScope };
/*
 * As tres series chegam com os numeros CRUS, e nao formatados.
 *
 * Dois motivos. Primeiro, quem as consome sao graficos e exportacao de CSV, e os
 * dois querem numero: um `recharts` nao plota "1.234" e o Excel nao soma "1,2 km".
 * Segundo, guardar tambem a versao formatada seria duas fontes para o mesmo valor.
 *
 * Formatar numero para leitura e trabalho de RENDERIZACAO, e e a view que o faz -
 * com o `format.ts` copiado da referencia, que e onde aquelas regras moram (ponto
 * de milhar, virgula decimal, metros para km).
 */
/** Um ponto da serie de cadastro e conexao. */
let OverviewPointScope = class OverviewPointScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.newUsers = 0;
        this.cumulativeUsers = 0;
        this.connectedUsers = 0;
        this.dailyAverageConnected = 0;
        this.activeUsersInWindow = 0;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "newUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "cumulativeUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "connectedUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "dailyAverageConnected", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OverviewPointScope.prototype, "activeUsersInWindow", void 0);
OverviewPointScope = __decorate([
    Observable
], OverviewPointScope);
export { OverviewPointScope };
/** Um ponto da serie de treinos. */
let TrainingPointScope = class TrainingPointScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.workouts = 0;
        this.users = 0;
        this.durationSeconds = 0;
        this.distanceMeters = 0;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingPointScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingPointScope.prototype, "workouts", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingPointScope.prototype, "users", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingPointScope.prototype, "durationSeconds", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingPointScope.prototype, "distanceMeters", void 0);
TrainingPointScope = __decorate([
    Observable
], TrainingPointScope);
export { TrainingPointScope };
/** Um ponto da serie de atividade fisica. */
let PhysicalPointScope = class PhysicalPointScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.steps = 0;
        this.usersWithSteps = 0;
        this.averageSteps = 0;
        this.distanceMeters = 0;
        this.usersWithDistance = 0;
        this.averageDistanceMeters = 0;
        this.calories = 0;
    }
    /** As distancias em km, CRUAS: o grafico plota numero, e o eixo diz a unidade. */
    get distanceKm() {
        return this.distanceMeters / 1000;
    }
    get averageDistanceKm() {
        return this.averageDistanceMeters / 1000;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "steps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "usersWithSteps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "averageSteps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "distanceMeters", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "usersWithDistance", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "averageDistanceMeters", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PhysicalPointScope.prototype, "calories", void 0);
PhysicalPointScope = __decorate([
    Observable
], PhysicalPointScope);
export { PhysicalPointScope };
/** Uma modalidade de treino, com os numeros crus que a tabela e o grafico usam. */
let TrainingTypeScope = class TrainingTypeScope extends Scope {
    constructor() {
        super(...arguments);
        this.type = '';
        this.label = '';
        this.workouts = 0;
        this.users = 0;
        this.totalDurationSeconds = 0;
        this.totalSteps = 0;
        this.totalDistanceMeters = 0;
        this.totalCalories = 0;
        this.averageHeartRate = null;
    }
    // O texto de cada celula da tabela de modalidades. Os numeros crus ficam acima,
    // para o CSV; a leitura e escrita aqui, uma vez, e nao na view.
    get workoutsLabel() {
        return formatCount(this.workouts);
    }
    get usersLabel() {
        return formatCount(this.users);
    }
    /** Treinos por colaborador naquela modalidade. */
    get perUserLabel() {
        return formatDecimal(this.users > 0 ? this.workouts / this.users : 0);
    }
    get durationLabel() {
        return formatDuration(this.totalDurationSeconds);
    }
    get distanceLabel() {
        return formatKm(this.totalDistanceMeters);
    }
    get heartRateLabel() {
        return this.averageHeartRate ? `${formatDecimal(this.averageHeartRate)} bpm` : '-';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "type", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "workouts", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "users", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "totalDurationSeconds", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "totalSteps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "totalDistanceMeters", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "totalCalories", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], TrainingTypeScope.prototype, "averageHeartRate", void 0);
TrainingTypeScope = __decorate([
    Observable
], TrainingTypeScope);
export { TrainingTypeScope };
/**
 * Um vestivel - pulseira ou anel - com a bateria do periodo.
 *
 * Os numeros crus ficam para o CSV; o texto de cada celula e escrito aqui, como na
 * linha de modalidade.
 */
let DeviceSourceScope = class DeviceSourceScope extends Scope {
    constructor() {
        super(...arguments);
        this.measurementSourceId = 0;
        this.label = '';
        this.users = 0;
        this.readings = 0;
        this.lowBatteryUsers = 0;
        this.midBatteryUsers = 0;
        this.highBatteryUsers = 0;
        this.usersWithDischarge = 0;
        this.medianDropPerDay = null;
        this.medianDaysPerCharge = null;
    }
    get usersLabel() {
        return formatCount(this.users);
    }
    get readingsLabel() {
        return formatCount(this.readings);
    }
    get lowLabel() {
        return formatCount(this.lowBatteryUsers);
    }
    get midLabel() {
        return formatCount(this.midBatteryUsers);
    }
    get highLabel() {
        return formatCount(this.highBatteryUsers);
    }
    /** `-` enquanto ninguem descarregou o bastante para medir. */
    get dropLabel() {
        return this.medianDropPerDay === null ? '-' : `${formatDecimal(this.medianDropPerDay)} pontos`;
    }
    /** De onde sai a mediana, para o `title` da celula. */
    get dropHint() {
        return `${formatCount(this.usersWithDischarge)} pessoas com descarga suficiente para medir`;
    }
    get daysPerChargeLabel() {
        return formatDaysPerCharge(this.medianDaysPerCharge);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "measurementSourceId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "users", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "readings", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "lowBatteryUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "midBatteryUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "highBatteryUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "usersWithDischarge", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "medianDropPerDay", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DeviceSourceScope.prototype, "medianDaysPerCharge", void 0);
DeviceSourceScope = __decorate([
    Observable
], DeviceSourceScope);
export { DeviceSourceScope };
/** `3,5 dias`, ou `-` quando ainda nao ha descarga suficiente para medir. */
export function formatDaysPerCharge(days) {
    return days === null ? '-' : `${formatDecimal(days)} dias`;
}
let UserBaseScope = class UserBaseScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        // :: filtros
        this.preset = '30d';
        this.granularity = 'DAY';
        /**
         * Quantos dias tem o intervalo - que e, desde 23/09/2026, a JANELA de atividade.
         *
         * Nao e mais escolha: era um seletor de 7, 15 ou 30 dias, herdado do painel antigo, e um
         * relatorio de 90 dias convivia com um cartao escrito "Ativos (30 dias)". Agora "ativo"
         * quer dizer "registrou algo no intervalo", e o numero no rotulo acompanha o que se pediu.
         *
         * Fica no scope so para os ROTULOS - quem calcula e o presenter, a partir das duas datas.
         */
        this.activeWindowDays = 30;
        this.customRange = false;
        /** Se esta tela oferece o seletor de empresa - so o admin o tem. */
        this.companyChooser = false;
        /**
         * O periodo que a resposta descreve, para a nota de metodologia.
         *
         * Datas em ISO, como o backend as manda: quem as formata e a view, com o
         * `formatDate` copiado - que converte sem passar por `Date`, para nao
         * deslocar um dia por fuso.
         */
        this.periodStart = '';
        this.periodEnd = '';
        this.granularityDescription = '';
        this.generatedAt = '';
        // :: visao geral
        this.hasOverview = false;
        /**
         * Os indicadores de RETRATO - a situacao na data de referencia.
         *
         * Eles ignoram a data inicial do filtro: `countUsersUntil` corta no fim, a janela de
         * ativos termina no fim (`fim + 1 - janela`), "Conectados" e o ULTIMO balde da serie e
         * os logins contam a janela que termina no fim. Mover o inicio nao mexe em nenhum.
         *
         * Estavam num array so com os de fluxo, numa grade de seis, debaixo de uma barra que
         * anunciava "Periodo: X a Y". A barra prometia recorte para tudo, e para quatro dos seis
         * o inicio nao valia nada - era a bagunca logica que esta separacao desfaz.
         */
        this.situationKpis = [];
        /**
         * Os indicadores de FLUXO - o que aconteceu ENTRE as duas datas.
         *
         * Sao os unicos da visao geral que usam o intervalo inteiro: cadastros criados no
         * periodo, e o maior dia de conectados dentro dele. As secoes de Treinos e de
         * Performance fisica sao inteiras de fluxo, e por isso nao precisam desta divisao.
         */
        this.flowKpis = [];
        this.funnel = [];
        this.overviewSeries = [];
        /** Quantos nunca sincronizaram, para o rodape do funil. */
        this.neverSyncedUsers = 0;
        // :: treinos
        this.hasTraining = false;
        this.trainingKpis = [];
        this.trainingTypes = [];
        this.trainingSeries = [];
        // :: atividade fisica
        this.hasPhysical = false;
        this.physicalKpis = [];
        this.physicalSeries = [];
        // :: vestiveis
        /** Falso tambem quando o servidor nao tem o painel - ai a secao simplesmente nao aparece. */
        this.hasDevices = false;
        this.deviceKpis = [];
        this.deviceSources = [];
        this.onGranularityChanged = Scope.SYNC_ACTION_STRING;
        this.onCompanyChanged = Scope.SYNC_ACTION_STRING;
        /** O "Atualizar" do topo: refaz as tres consultas sem mudar filtro algum. */
        this.onRefresh = Scope.ASYNC_ACTION;
        /**
         * As exportacoes em CSV, uma por quadro.
         *
         * O conteudo e montado pela apresentacao (ver `csv.ts` do dominio), e quem salva e
         * o `FileSaver` que o renderizador instala. Ate 08/10/2026 a view montava e baixava.
         */
        this.onExportOverview = Scope.ASYNC_ACTION;
        this.onExportTrainingTypes = Scope.ASYNC_ACTION;
        this.onExportTrainingSeries = Scope.ASYNC_ACTION;
        this.onExportPhysical = Scope.ASYNC_ACTION;
        this.onExportDevices = Scope.ASYNC_ACTION;
    }
    get periodStartLabel() {
        return formatDate(this.periodStart);
    }
    get periodEndLabel() {
        return formatDate(this.periodEnd);
    }
    get generatedAtLabel() {
        return formatDateAtTime(this.generatedAt);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], UserBaseScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], UserBaseScope.prototype, "preset", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], UserBaseScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], UserBaseScope.prototype, "granularity", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "activeWindowDays", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "customRange", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], UserBaseScope.prototype, "companySelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "companyChooser", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "periodStart", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "periodEnd", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "granularityDescription", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], UserBaseScope.prototype, "companyName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "generatedAt", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "hasOverview", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "situationKpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "flowKpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "funnel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "overviewSeries", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "neverSyncedUsers", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "hasTraining", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "trainingKpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "trainingTypes", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "trainingSeries", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "hasPhysical", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "physicalKpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "physicalSeries", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], UserBaseScope.prototype, "hasDevices", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "deviceKpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], UserBaseScope.prototype, "deviceSources", void 0);
UserBaseScope = __decorate([
    Observable
], UserBaseScope);
export { UserBaseScope };
//# sourceMappingURL=user-base.scope.js.map